module.exports = __webpack_public_path__ + "static/media/background_header.8b8aa370.png";